<script lang="ts" setup>
import GwTooltipNew from '@/components/lib/GwTooltip/GwTooltipNew.vue'
import { getSiteItem } from '@/helpers/helpers'
import { computed } from 'vue'
import type { TUiTypeValues } from '@/types/api/reports'

interface GwSiteItemProps {
  value: TUiTypeValues['site']
  tstPrefix?: string
  onlyIcon?: boolean
  iconAndText?: boolean
  iconAndTooltip?: boolean

  disableTranslate?: boolean
  icon?: string
  title?: string
}

const props = withDefaults(defineProps<GwSiteItemProps>(), {
  tstPrefix: 'item',
  iconAndText: true,
})

const site = computed(() => getSiteItem(props.value))

const imgSrc = computed(() => {
  if (site.value) {
    return new URL(`/src/assets/playhouses/${site.value.img}.webp`, import.meta.url).href
  }
  return null
})
const tooltip = computed(() => (site.value ? site.value.name : props.value))
</script>
<template>
  <div
    v-if="iconAndText || onlyIcon"
    class="gw_site_item mw-0"
    :data-tst="`${tstPrefix}_siteitem_${value}`"
  >
    <div
      v-if="icon"
      class="mdi"
      :class="icon"
      style="font-size: 1.5rem"
    />
    <img
      v-else-if="imgSrc"
      :src="imgSrc"
    />
    <div
      v-else
      class="gw_site_item_greycircle"
    ></div>
    <div
      v-if="iconAndText"
      class="truncate line-height_initial"
      :title="title || (site ? site.name : value)"
    >
      {{ title || (disableTranslate ? value : site ? site.name : value) }}
    </div>
  </div>
  <div
    v-else-if="iconAndTooltip"
    class="d-flex f-start"
  >
    <GwTooltipNew
      :tooltip
      placement="right"
    >
      <template #opener="{ listeners }">
        <div
          class="gw_site_item mw-0"
          v-on="listeners"
        >
          <div
            v-if="icon"
            class="mdi"
            :class="icon"
            style="font-size: 1.5rem"
          />
          <img
            v-else-if="imgSrc"
            :src="imgSrc"
          />
          <div
            v-else
            class="gw_site_item_greycircle"
          ></div>
        </div>
      </template>
    </GwTooltipNew>
  </div>
</template>
<style lang="scss" scoped>
.gw_site_item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  img {
    width: 1.25em;
  }
  &_greycircle {
    flex-shrink: 0;
    width: 1.25em;
    height: 1.25em;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.125);
  }
}
</style>
